import React, { PropTypes } from 'react';
import ModalDialog from 'common/components/modal/modal_dialog';
import DetailsForm from 'focus_groups/containers/details_form';
import EntryPicker from 'focus_groups/containers/entry_picker';
import Participants from 'focus_groups/containers/participants';

const AddModals = ({ toggle, showAddModal, addModalStep }) => {
  if (!showAddModal) {
    return null;
  }

  return (<div>
    <ModalDialog
      dialogClasses="focus-group-modal"
      modalOpen={addModalStep === 1}
      closeAction={toggle}
      modalHeader="Create Focus Group - Step 1 of 3"
    >
      <DetailsForm />
    </ModalDialog>
    <ModalDialog
      dialogClasses="focus-group-modal"
      modalOpen={addModalStep === 2}
      closeAction={toggle}
      contentClasses="wide"
      modalHeader="Create Focus Group - Step 2 of 3"
    >
      <EntryPicker />
    </ModalDialog>
    <ModalDialog
      dialogClasses="focus-group-modal"
      modalOpen={addModalStep === 3}
      closeAction={toggle}
      modalHeader="Create Focus Group - Step 3 of 3"
    >
      <Participants />
    </ModalDialog>
  </div>);
};

AddModals.propTypes = {
  toggle: PropTypes.func.isRequired,
  showAddModal: PropTypes.bool.isRequired,
  addModalStep: PropTypes.number,
};

export default AddModals;



// WEBPACK FOOTER //
// ./focus_groups/components/add_modals.jsx